import script from "./IOrderMenuLegacy.vue?vue&type=script&setup=true&lang=js"
export * from "./IOrderMenuLegacy.vue?vue&type=script&setup=true&lang=js"

import "./IOrderMenuLegacy.vue?vue&type=style&index=0&id=28395c19&lang=scss"

const __exports__ = script;

export default __exports__